import { DialogFooter } from '@shared/components/shadcn';
import type { ReactNode } from 'react';
import { z } from 'zod';
import type { PlayerAddressData } from './hooks/types';
type FormValues = {
  'edit-address': {
    addressLookup?: string;
    address: {
      streetNr: string;
      streetName: string;
      // addressLine1: string;
      /** `extraAddressField` */
      addressLine2: string;
      /** Town/City for UK addresses */
      addressLevel2: string;
      postalCode: string;
    };
  };
};

function getFormSchema(t: (key: string) => string) {
  return z.object({
    'edit-address': z.object({
      addressLookup: z.string().optional(),
      address: z.object({
        streetNr: z.string().min(1, t('edit_step.street_nr_required')),
        streetName: z.string().min(1, t('edit_step.street_name_required')),
        // addressLine1: z.string().min(1, t('edit_step.address_line_1_required')),
        addressLine2: z.string(),
        addressLevel2: z.string().min(1, t('edit_step.address_level2_required')),
        postalCode: z
          .string()
          .min(1, t('edit_step.postal_code_required'))
          // NOTE: This regex works for the UK only - will need updates for other markets
          .regex(/^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i, t('edit_step.postal_code_invalid'))
          .transform(val => val.toUpperCase().replace(/\s/g, '')),
      }),
    }),
  });
}

function formatAddress(data: PlayerAddressData): string {
  return [data.extraAddressField, [data.streetNr, data.streetName].filter(Boolean).join(' '), [data.city, data.postCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

type ReKycStepHeaderProps = {
  headerIcon: ReactNode;
  title: ReactNode;
  description: ReactNode;
};

function ReKycStepHeader({ headerIcon, title, description }: ReKycStepHeaderProps) {
  return (
    <div className="flex flex-col gap-4 mb-6 pt-10 md:pt-6">
      <div aria-hidden="true">{headerIcon}</div>
      <div className="flex flex-col gap-2">
        <h3 className="heading-4" data-testid="rekyc-step-title">
          {title}
        </h3>
        <p className="text-foreground-subtle" data-testid="rekyc-step-description">
          {description}
        </p>
      </div>
    </div>
  );
}

type ReKycStepFooterProps = {
  actions?: ReactNode;
};

function ReKycStepFooter({ actions }: ReKycStepFooterProps) {
  if (!actions) return null;
  return (
    <DialogFooter className="flex-1 justify-self-end" data-track-container="Actions">
      {actions}
    </DialogFooter>
  );
}

export { formatAddress, getFormSchema, ReKycStepFooter, ReKycStepHeader, type FormValues };
